<form class="event-add__form-container" [formGroup]="addEventForm" #formDir="ngForm">
  <h1 id="form-title">Submit New Event</h1>
  <fieldset class="event-add__form-section">
    <legend class="event-add__form-section-title">Event Info</legend>
    <mat-form-field class="event-add__formItem">
      <mat-label>Event Title *</mat-label>
      <input matInput formControlName="title" placeholder="Event Title" maxlength="256"/>
    </mat-form-field>
    <mat-form-field class="event-add__formItem" hintLabel="(200 characters max)">
      <mat-label>Event Short Description *</mat-label>
      <textarea
        rows="3"
        matInput
        placeholder="Short Description"
        formControlName="shortDescription"
        maxlength="200"
        (keyup)="shortEventKeyUp($event)">
        </textarea>
      <mat-hint align="end">Characters: {{shortEventDescCharCount}}/{{shortEventDescMaxChars}}</mat-hint>
    </mat-form-field>
    <mat-form-field class="event-add__formItem">
      <mat-label>Event Description *</mat-label>
      <textarea
        rows="5"
        matInput
        placeholder="Event Description"
        formControlName="description">
        </textarea>
    </mat-form-field>
    <div class="event-add__horizontal-fields">
      <mat-form-field class="event-add__formItem">
        <mat-label>Event Type *</mat-label>
        <mat-select formControlName="type">
          <mat-option value="{{event}}" *ngFor="let event of eventTypes">{{event}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="event-add__formItem">
        <mat-label>Event Format *</mat-label>
        <mat-select (selectionChange)="eventFormatSelectionChange($event)" formControlName="format">
          <mat-option value="{{eventFormat}}" *ngFor="let eventFormat of eventFormats">{{eventFormat}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="event-add__horizontal-fields">
      <mat-form-field class="event-add__formItem">
        <mat-label>Event Info Website Link</mat-label>
        <input matInput formControlName="informationWebsite"
               (keyup)="informationWebsiteKeyUP($event)" maxlength="256"/>
      </mat-form-field>
      <mat-form-field class="event-add__formItem" hintLabel="(Optional - This text will replace the website info label)">
        <mat-label>Event Website Custom Label</mat-label>
        <input matInput formControlName="websiteCustomLabel" placeholder="Custom Label" maxlength="50"/>
      </mat-form-field>
    </div>
    <mat-form-field class="event-add__formItem">
      <mat-label>Event Registration Link</mat-label>
      <input matInput formControlName="webinarRegistrationLink"
             (keyup)="webinarRegistrationKeyUp($event)" maxlength="256"/>
    </mat-form-field>
    <mat-form-field class="event-add__formItem">
      <mat-label>Event Cost</mat-label>
      <input matInput formControlName="cost" placeholder="Enter Cost" maxlength="256">
    </mat-form-field>
  </fieldset>
  <fieldset class="event-add__form-section">
    <legend class="event-add__form-section-title">Images (Optional)</legend>
    <mat-hint id="coverphoto-hint">(Format accepted for each image: jpg, jpeg, png. Maximum 10MB file size)</mat-hint>

    <div class="event-add__photoSubheader">Cover Photo/Thumbnail</div>
    <input #coverPhotoFile class="event-add__form_field_file" formControlName="coverPhoto" type="file" (change)="onPhotoCoverChange($event)"/>
    <mat-error class="event-add__form_field_padding" *ngIf="hasInvalidFileType('coverPhoto')">Invalid File
      Type: File must be JPG, JPEG, or PNG
    </mat-error>
    <mat-error class="event-add__form_field_padding" *ngIf="photoIsTooLarge('coverPhoto')">File Too Large: File must be below 10MB</mat-error>

    <div class="event-add__photoSubheader">Additional Photo 1</div>
    <input #additionalPhoto1File class="event-add__form_field_file" formControlName="additionalPhoto1" type="file" (change)="onAdditionalPhoto1Change($event)"/>
    <mat-error class="event-add__form_field_padding" *ngIf="hasInvalidFileType('additionalPhoto1')">Invalid File
      Type: File must be JPG, JPEG, or PNG
    </mat-error>
    <mat-error class="event-add__form_field_padding" *ngIf="photoIsTooLarge('additionalPhoto1')">File Too Large: File must be below 10MB</mat-error>

    <div class="event-add__photoSubheader">Additional Photo 2</div>
    <input #additionalPhoto2File class="event-add__form_field_file" formControlName="additionalPhoto2" type="file" (change)="onAdditionalPhoto2Change($event)"/>
    <mat-error class="event-add__form_field_padding" *ngIf="hasInvalidFileType('additionalPhoto2')">Invalid File
      Type: File must be JPG, JPEG, or PNG
    </mat-error>
    <mat-error class="event-add__form_field_padding" *ngIf="photoIsTooLarge('additionalPhoto2')">File Too Large: File must be below 10MB</mat-error>
  </fieldset>
  <fieldset class="event-add__form-section">
    <legend class="event-add__form-section-title">Location</legend>
    <mat-form-field class="event-add__formItem" *ngIf="showAddressFields">
      <mat-label>Venue/Location Name *</mat-label>
      <input formControlName="venueLocationName" matInput placeholder="Venue Name" maxlength="256"/>
    </mat-form-field>
      <h3 *ngIf="showAddressFields">Event Address *</h3>
      <div
        style="border-width: 1px; border-color: black; border-style: solid; padding: 5px; display: flex; flex-direction: column">
        <mat-form-field class="event-add__formItem">
          <mat-label>Select Country *</mat-label>
          <mat-select formControlName="country" (selectionChange)="statesFieldChanged($event)">
            <mat-option value="{{country.countryCode}}" *ngFor="let country of countries">{{country.countryName}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-checkbox *ngIf="isUSorCA() && isFlightDeckAdmin" formControlName="overrideAddressLookup" color="primary"
                      (change)="overrideAddressLookupChanged()">
          Manually enter address (skip Google address verification)
        </mat-checkbox>
        <mat-hint *ngIf="isUSorCA() && isFlightDeckAdmin && addEventForm.value.overrideAddressLookup">
          Address will be saved exactly as entered. You must provide the latitude/longitude below.
        </mat-hint>
        <ng-container *ngIf="showAddressFields">
        <mat-form-field class="event-add__formItem">
          <mat-label *ngIf="isUSorCA()">Street 1 *</mat-label>
          <mat-label *ngIf="!isUSorCA()">Address Line 1 *</mat-label>
          <input formControlName="address1" matInput placeholder="Enter Address Line 1" maxlength="256"/>
        </mat-form-field>
        <mat-form-field class="event-add__formItem">
          <mat-label *ngIf="isUSorCA()">Street 2</mat-label>
          <mat-label *ngIf="!isUSorCA()">Address Line 2</mat-label>
          <input matInput formControlName="address2" placeholder="Enter Address Line 2" maxlength="256"/>
        </mat-form-field>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Address Line 3</mat-label>
          <input matInput formControlName="address3" placeholder="Enter Address Line 3" maxlength="256"/>
        </mat-form-field>
        <div *ngIf="isUSorCA()" class="event-add__horizontal-fields">
          <mat-form-field class="event-add__formItem">
            <mat-label>City *</mat-label>
            <input matInput formControlName="city" placeholder="City" maxlength="256"/>
          </mat-form-field>
          <mat-form-field class="event-add__formItem">
            <mat-label>Select State/Province *</mat-label>
            <mat-select *ngIf="getStates().length; else statesTextField" formControlName="stateProvince">
              <mat-option value="{{state}}" *ngFor="let state of getStates()">{{state}}</mat-option>
            </mat-select>
            <ng-template #statesTextField>
              <input matInput formControlName="stateProvince" placeholder="State/Province"/>
            </ng-template>
          </mat-form-field>
          <mat-form-field class="event-add__formItem">
            <mat-label>Zip Code *</mat-label>
            <input matInput formControlName="zipcode" placeholder="Zip Code" maxlength="20"/>
          </mat-form-field>
        </div>
        <mat-form-field *ngIf="showLatLng()" class="event-add__formItem">
          <mat-label>Latitude *</mat-label>
          <input matInput formControlName="latitude" placeholder="Enter latitude in decimal degrees" maxlength="12"/>
        </mat-form-field>
        <mat-form-field *ngIf="showLatLng()" class="event-add__formItem">
          <mat-label>Longitude *</mat-label>
          <input matInput formControlName="longitude" placeholder="Enter longitude in decimal degrees" maxlength="12"/>
        </mat-form-field>
        </ng-container>
      </div>
      <div class="event-add__flex-columns" *ngIf="showAddressFields">
        <mat-checkbox formControlName="isOnAirport" color="primary" style="padding-top: 1em">Located on Airport
          Grounds
        </mat-checkbox>
        <mat-form-field *ngIf="isUSorCA()" class="event-add__formItem" style="padding-top: 1em" (focusout)="airportSearchFocusOut($event)">
          <mat-label>Select Airport</mat-label>
          <input type="text" matInput formControlName="airport" [matAutocomplete]="auto"
                 placeholder="Search Airport By Ident or Name" (keyup)="airportQueryKeyUp($event)"/>
        </mat-form-field>
        <mat-autocomplete #auto="matAutocomplete">
          <mat-option (onSelectionChange)="airportChange(airport)" *ngFor="let airport of airports"
                      [value]="airport.identifier + ': ' + airport.name">{{airport.identifier}}
            : {{airport.name}}</mat-option>
        </mat-autocomplete>
        <mat-error class="event-add__form_field_padding" *ngIf="airportSelectionError">Invalid Airport</mat-error>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Airport Identifier</mat-label>
          <input matInput formControlName="internationalAirportId" placeholder="Enter airport identifier" maxlength="30"/>
        </mat-form-field>
        <mat-form-field *ngIf="!isUSorCA()" class="event-add__formItem">
          <mat-label>Airport Name</mat-label>
          <input matInput formControlName="internationalAirportName" placeholder="Enter airport name" maxlength="256"/>
        </mat-form-field>
      </div>
  </fieldset>
  <fieldset class="event-add__form-section">
    <legend class="event-add__form-section-title">Date &amp; Time</legend>
    <mat-error class="event-add__form_field_padding" *ngIf="showDateError()">start time cannot be after end time</mat-error>
    <div class="event-add__horizontal-fields">
      <mat-form-field>
        <input matInput
               name="startDate"
               formControlName="startDate"
               [matDatepicker]="startPicker"
               [min]="startDateMin"
               placeholder="Pick Start Date"
               (dateChange)="eventDateChange('input', $event)"/>
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>

      <div class="event-add__time-header">Select Start Time:</div>
      <mat-form-field>
        <mat-select placeholder="Hour" formControlName="startHour">
          <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="event-add__time-colon">:</div>
      <mat-form-field>
        <mat-select placeholder="Minute" formControlName="startMin">
          <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="AM/PM" formControlName="startAMPM">
          <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="event-add__horizontal-fields">
      <mat-form-field>
        <input
          name="endDate"
          formControlName="endDate"
          matInput [matDatepicker]="endPicker"
          [min]="endDateMin"
          placeholder="Pick End Date"
          (dateChange)="eventDateChange('input', $event)"/>
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>

      <div class="event-add__time-header">Select End Time:</div>
      <mat-form-field>
        <mat-select placeholder="Hour" formControlName="endHour">
          <mat-option value="{{hour}}" *ngFor="let hour of eventHours">{{hour}}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="event-add__time-colon">:</div>
      <mat-form-field>
        <mat-select placeholder="Minute" formControlName="endMin">
          <mat-option value="{{min}}" *ngFor="let min of eventMinutes">{{min}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-select placeholder="AM/PM" formControlName="endAMPM">
          <mat-option value="{{ampm}}" *ngFor="let ampm of eventAMPM">{{ampm}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <mat-form-field class="event-add__formItem">
      <mat-label>Time Zone *</mat-label>
      <mat-select formControlName="timezone">
        <mat-option value="{{tz.zoneName}}" *ngFor="let tz of timezones">{{tz.zoneName}}</mat-option>
      </mat-select>
    </mat-form-field>
  </fieldset>
  <fieldset class="event-add__form-section">
    <legend class="event-add__form-section-title">Contact</legend>
    <mat-form-field class="event-add__formItem">
      <mat-label>Contact Person Name *</mat-label>
      <input matInput formControlName="contactPersonName" placeholder="Contact Name" maxlength="256"/>
    </mat-form-field>
    <mat-form-field class="event-add__formItem">
      <mat-label>Contact Person Email *</mat-label>
      <input matInput formControlName="contactPersonEmail" placeholder="Enter Email" maxlength="256"/>
    </mat-form-field>
    <mat-form-field class="event-add__formItem">
      <mat-label>Contact Person Phone *</mat-label>
      <input type="tel" matInput formControlName="contactPersonPhone" placeholder="Phone" maxlength="256"/>
    </mat-form-field>
  </fieldset>
  <fieldset class="event-add__form-section" *ngIf="isFlightDeckAdmin">
    <legend class="event-add__form-section-title">AOPA</legend>
    <div style="display: flex; flex-direction: column; gap: 1em; padding: 1em 0 2em 0">
      <mat-checkbox formControlName="isValidated" color="primary">Event Validated</mat-checkbox>
      <mat-checkbox formControlName="isFeatured" color="primary">Featured Event</mat-checkbox>
      <mat-checkbox formControlName="hasAopaPresence" color="primary">AOPA Presence at Event</mat-checkbox>
      <mat-checkbox formControlName="isAopaHosted" color="primary">AOPA Hosted Event</mat-checkbox>
    </div>
  </fieldset>
  <div style="display: flex; flex-direction: row; gap: 1em; padding: 1em; margin: 2em 2em; ">
    <button mat-raised-button color="primary" [class.spinner]="isSaving" [disabled]="isSaving" (click)="onSubmit(this.addEventForm)">Submit</button>
    <button mat-raised-button color="warn" (click)="cancelButtonClicked($event)">Cancel</button>
  </div>
</form>
